import React from "../../../__snowpack__/pkg/react.js";
export const TagsContext = React.createContext({searchType: "simple", searchMode: "collapse"});
